import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import React, { useCallback, useState } from 'react';

const defaultOptions = {
    title: 'Are you sure?',
    description: '',
    confirmationText: 'Ok',
    cancellationText: 'Cancel',
    dialogProps: {},
    loading: false,
    onClose: () => {},
    onCancel: () => {},
};

const withConfirm = (WrappedComponent) => (props) => {
    const [onConfirm, setOnConfirm] = useState(null);
    const [options, setOptions] = useState(defaultOptions);
    const {
        title,
        description,
        confirmationText,
        cancellationText,
        dialogProps,
        onClose,
        onCancel,
    } = options;

    const handleClose = useCallback(() => {
        onClose();
        setOnConfirm(null);
    }, [onClose]);

    const handleCancel = useCallback(() => {
        onCancel();
        handleClose();
    }, [onCancel, handleClose]);

    const handleConfirm = useCallback((...args) => {
        onConfirm(...args);
        handleClose();
    }, [onConfirm, handleClose]);

    /* Returns function opening the dialog, passed to the wrapped component. */
    const confirm = useCallback((onConfirm, options = {}) => () => {
        setOnConfirm(() => onConfirm);
        setOptions({ ...defaultOptions, ...options });
    }, []);

    return (
        <>
            <WrappedComponent {...props} confirm={confirm} />

            <Dialog
                {...dialogProps}
                fullWidth
                maxWidth="xs"
                open={!!onConfirm}
                onClose={handleCancel}
                disableBackdropClick
            >
                {title && (
                    <DialogTitle disableTypography>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography variant="h6">{title}</Typography>
                            <IconButton onClick={handleCancel}><CloseIcon /></IconButton>
                        </Box>
                    </DialogTitle>
                )}
                {description && (
                    <DialogContent>
                        <DialogContentText>{description}</DialogContentText>
                    </DialogContent>
                )}
                <DialogActions>
                    <Button onClick={handleCancel}>
                        {cancellationText}
                    </Button>
                    <Button onClick={handleConfirm} color="primary" variant="contained">
                        {confirmationText}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

export default withConfirm;
